const extractChatIdPart = (
  chatId: string,
  index: 0 | 1,
  fallback: string
): string => {
  const parts = chatId.split("#");
  return parts[index] ?? fallback;
};

export const extractSenderId = (chatId: string): string => {
  return extractChatIdPart(chatId, 0, "");
};

export const extractReceiverId = (chatId: string): string => {
  return extractChatIdPart(chatId, 1, chatId);
};

export const extractSenderIdWithFallback = (chatId: string): string => {
  return extractChatIdPart(chatId, 0, chatId);
};
